import { useState } from "react";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import {
  isAuthenticated,
  addTimeInterval,
} from "../../../ApiService/ApiService";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import moment from "moment";
import CustomDialog from "../../../Components/CustomDialog";

function AddTimeInterval({ fetchIntervals, setShowAddTimeInterval }) {
  const schoolId = parseInt(sessionStorage.getItem("schoolId"));
  const [formData, setFormData] = useState({
    name: "",
    startTime: null,
    endTime: null,
    schoolId: schoolId,
  });
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    message: "",
    buttons: [],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const formattedFormData = {
    ...formData,
    startTime: moment(formData.startTime).format("HH:mm"),
    endTime: moment(formData.endTime).format("HH:mm"),
  };

  const handleDialogClose = () => {
    setDialog({ ...dialog, visible: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !formData.name ||
      !formData.startTime ||
      !formData.endTime ||
      !formData.schoolId
    ) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Please fill in all the required details.",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
      return;
    }

    setLoading(true);

    try {
      if (isAuthenticated()) {
        const response = await addTimeInterval(formattedFormData);
        // console.log("RES", response?.data);
        if (response) {
          if (response?.data?.status === 200) {
            setDialog({
              visible: true,
              title: "Success",
              message: "Time Interval added",
              buttons: [{ name: "OK", onPress: handleDialogClose }],
            });
            setFormData({
              name: "",
              startTime: null,
              endTime: null,
              schoolId: schoolId,
            });
            fetchIntervals();
            setShowAddTimeInterval(false);
          } else {
            const errorMessage =
              response?.data?.errorMessage || "Something went wrong";
            setDialog({
              visible: true,
              title: "Error",
              message: errorMessage,
              buttons: [{ name: "Close", onPress: handleDialogClose }],
            });
          }
        } else {
          setDialog({
            visible: true,
            title: "Error",
            message: "Invalid response from the server",
            buttons: [{ name: "Close", onPress: handleDialogClose }],
          });
        }
      } else {
        setDialog({
          visible: true,
          title: "Unauthorized action",
          message: "Please login and try again",
          buttons: [{ name: "Close", onPress: handleDialogClose }],
        });
      }
    } catch (error) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Something went wrong",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomDialog
        visible={dialog.visible}
        title={dialog.title}
        message={dialog.message}
        buttons={dialog.buttons}
        onClose={handleDialogClose}
      />
      <Box sx={{ maxWidth: "75%", margin: "auto", padding: 3 }}>
        <Paper elevation={3} sx={{ padding: 5 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: 600, fontSize: 22, color: "black " }}
          >
            Add Time Interval
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DemoContainer components={["TimePicker"]}>
                    <TimePicker
                      label="Start Time"
                      sx={{ width: "100%" }}
                      name="startTime"
                      value={formData.startTime}
                      onChange={(newValue) =>
                        setFormData({
                          ...formData,
                          startTime: newValue,
                        })
                      }
                      renderInput={(params) => <TextField {...params} />}
                      required
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DemoContainer components={["TimePicker"]}>
                    {" "}
                    <TimePicker
                      label="End Time"
                      sx={{ width: "100%" }}
                      name="endTime"
                      value={formData.endTime}
                      onChange={(newValue) =>
                        setFormData({
                          ...formData,
                          endTime: newValue,
                        })
                      }
                      renderInput={(params) => <TextField {...params} />}
                      required
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Button
                  fullWidth
                  variant="contained"
                  color="inherit"
                  onClick={() => setShowAddTimeInterval(false)}
                  startIcon={<ArrowBack />}
                  sx={{ textTransform: "unset" }}
                >
                  Back
                </Button>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={loading}
                  endIcon={<ArrowForward />}
                  sx={{ textTransform: "unset" }}
                >
                  {loading ? "Loading..." : "Submit"}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
    </>
  );
}

export default AddTimeInterval;
